import GradeLessonPage from '../../../grades/components/GradeLessonPage';
import { preAlgebraTopic } from './pre-algebra';
import { elementaryAlgebraTopic } from './elementary-algebra';
import { intermediateAlgebra } from './intermediate-algebra';
import { coordinateGeometry } from './coordinate-geometry';
import { planeGeometry } from './plane-geometry';
import { trigonometry } from './trigonometry';

export default function ACTMathPage() {
  const topics = [
    preAlgebraTopic,
    elementaryAlgebraTopic,
    intermediateAlgebra,
    coordinateGeometry,
    planeGeometry,
    trigonometry,
  ];

  return (
    <>
      {/* Quick Access Banners */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
        <a
          href="/act-math-worksheets"
          className="block bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl p-6 text-white hover:shadow-xl transition-shadow group"
        >
          <div className="flex items-center justify-between mb-3">
            <i className="ri-file-list-3-line text-3xl"></i>
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </div>
          <h3 className="text-xl font-bold mb-2">Browse All Worksheets</h3>
          <p className="text-blue-100 text-sm">Filter 66 topic-specific drills by domain</p>
        </a>

        <a
          href="/act-math-study-plan"
          className="block bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-6 text-white hover:shadow-xl transition-shadow group"
        >
          <div className="flex items-center justify-between mb-3">
            <i className="ri-calendar-check-line text-3xl"></i>
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </div>
          <h3 className="text-xl font-bold mb-2">Get Study Plan</h3>
          <p className="text-green-100 text-sm">Weekly prep schedule for test day</p>
        </a>

        <a
          href="/act-math-progress"
          className="block bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl p-6 text-white hover:shadow-xl transition-shadow group"
        >
          <div className="flex items-center justify-between mb-3">
            <i className="ri-checkbox-circle-line text-3xl"></i>
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </div>
          <h3 className="text-xl font-bold mb-2">Track Progress</h3>
          <p className="text-purple-100 text-sm">Mark worksheets complete and see stats</p>
        </a>
      </div>

      <GradeLessonPage
        grade="ACT Math"
        gradeLabel="ACT Math Test Prep"
        gradeColor="violet"
        topics={topics}
      />
    </>
  );
}